import React, { Fragment } from 'react';
import { Menu, Transition, Listbox } from '@headlessui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const Dropdown = ({ button, children }) => {
  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <Menu.Button>{button}</Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="z-10 origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="py-1">{children}</div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export const ListBox = ({
  initialValue,
  value,
  buttonText,
  handleChange,
  listBoxClass,
  children,
}) => {
  return (
    <Listbox value={value || initialValue} onChange={handleChange}>
      <div className={`${listBoxClass} relative mt-1`}>
        <Listbox.Button className="relative w-full cursor-pointer rounded-lg bg-light-blue py-2 px-5 text-left border border-extra-light-gray z-20">
          <span className="block truncate capitalize ml-3 mr-6">
            {buttonText}
          </span>
          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
            <FontAwesomeIcon
              icon={['far', 'angle-down']}
              className="mx-4 mb-1"
            />
          </span>
        </Listbox.Button>
        <Transition
          as={Fragment}
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Listbox.Options className="absolute mt-[0.25] z-1 max-h-60 w-full overflow-auto rounded-md bg-white text-base border border-navy-blue border-opacity-30">
            {children}
          </Listbox.Options>
        </Transition>
      </div>
    </Listbox>
  );
};
